// src/pages/Results.js
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE } from "../api";
import glava from "../assets/glava.png";
import "./Results.css";

export default function Results() {
  const { sessionId, role } = useParams();
  const navigate = useNavigate();

  const [data, setData] = useState(null);
  const [showResult, setShowResult] = useState(false);

  // 🔤 letter writing state
  const [typed, setTyped] = useState("");
  const [charIndex, setCharIndex] = useState(0);
  const [typingDone, setTypingDone] = useState(false); // ⬅️ DODANO

  useEffect(() => {
    if (!sessionId) return;

    const interval = setInterval(async () => {
      try {
        const res = await fetch(
          `${API_BASE}/get_results?session_id=${sessionId}`
        );
        const json = await res.json();

        if (json && json.analysis) {
          setData(json);
          clearInterval(interval);

          setTimeout(() => {
            setShowResult(true);
          }, 20000);
        }
      } catch (e) {
        console.error("Error fetching results", e);
      }
    }, 2500);

    return () => clearInterval(interval);
  }, [sessionId]);

  // 🔤 letter writing effect (RESULT)
  useEffect(() => {
    if (!showResult || !data?.analysis) return;

    if (charIndex < data.analysis.length) {
      const t = setTimeout(() => {
        setTyped(prev => prev + data.analysis[charIndex]);
        setCharIndex(i => i + 1);
      }, 28);
      return () => clearTimeout(t);
    } else {
      setTypingDone(true); // ⬅️ KLJUČNO
    }
  }, [charIndex, showResult, data]);

  // 🔮 PREPARING
  if (!showResult) {
    return (
      <div
        className="results-preparing"
        style={{ backgroundImage: `url(${glava})` }}
      >
        <div className="preparing-overlay">
          <p className="preparing-text">Preparing reflection…</p>

          <p className="jung-quote">
            “The meeting of two personalities is like the contact of two chemical substances:
            if there is any reaction, both are transformed.”
            <br />
            <span className="jung-author">— Carl Jung</span>
          </p>
        </div>
      </div>
    );
  }

  // 📖 RESULT
  return (
    <div className="fade-in results-container">
      <div className="card analysis-box">
        <p className="reflection-body">{typed}</p>

        {typingDone && ( // ⬅️ SAMO PO KONCU PISANJA
          <div style={{ textAlign: "center", marginTop: 36 }}>
            <button
              className="btn btn-primary"
              onClick={() =>
                navigate(`/module2/${sessionId}/${role}`)
              }
            >
              Continue to Module 2
            </button>
          </div>
        )}
      </div>
    </div>
  );
} 